<template lang="pug">
  div.text-center
    header
      main-header
    main.container
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20",
        v-if="modulos && modulos.length > 0"
      )
        p.text-center(v-if="modulos && modulos.length > 0") Clique sobre o botão correspondente ao módulo que deseja no sistema:
        p.text-center(v-else="modulos && modulos.length == 0") Este usuário não possui acesso a nenhum módulo do sistema.
      el-row.container(
        type="flex",
        justify="center",
        :gutter="20"
        v-if="modulos"
      )
        el-col.margin-bottom(@click.native="setModulo(modulo)", :xs="24", :sm="15", :md="10", :lg="8", :xl="4", v-for = "modulo in modulos", :key="modulo.id")
          el-card.card
            div(slot="header")
              img.perfil(:src="imgModulo(modulo)")
            div
              span {{ modulo.nome }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MainHeader from '@/components/MainHeader';

export default {
  components: {
    MainHeader,
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado',
    }),
  },

  data() {
    return {
      modulos: [],
    };
  },

  async mounted() {
    this.modulos = await this.buscarModulos();
    if (this.modulos && this.modulos.length == 1) {
      await this.selecioneModulo({ moduloId: this.modulos[0].id });
      this.$router.push({
        name: 'selecionarPerfil',
      });
    }
  },

  methods: {
    ...mapActions({
      selecioneModulo: 'auth/selecioneModulo',
      selecionePerfil: 'auth/selecionePerfil',
      buscarModulos: 'auth/buscarModulos',
    }),

    async setModulo(modulo) {
      await this.selecioneModulo({ moduloId: modulo.id });
      this.$router.push({ name: 'selecionarPerfil' });
    },

    imgModulo(modulo) {
      return require('@/assets/images/modulos/' + modulo.codigo.toLowerCase() + '.png');
    },
  },
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.container {
  width: 100%;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  * {
    flex-wrap: wrap;
  }
}

.card {
  height: 100%;
  flex-wrap: wrap;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
    transition-property: 2s;
  }
}

.margin-bottom {
  margin: 1%;
}

/deep/ .el-card__body {
  padding: 10px;
}

.perfil {
  width: 180px;
  height: 180px;
}
</style>
